export default __webpack_public_path__ + "static/media/order-delivery.77b4c5da.svg";